export default __webpack_public_path__ + "static/media/triangle.2a5bd31e.png";